<template>
  <div style="position: relative;">
    <el-form ref="titlesPageFilter" :model="titlesPage" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="职称" prop="formFilter.titleName">
          <el-input class="filter-item" v-model="titlesPage.formFilter.titleName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetTitlesPage">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshTitlesPage(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('titlesPage:titlesPage:titleEditAdd')"
          @click="onTitleEditAddClick()">
          新增
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="sysTitles" :data="titlesPage.SysTitles.impl.dataList" :size="defaultFormItemSize" @sort-change="titlesPage.SysTitles.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="titlesPage.SysTitles.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="titlesPage.SysTitles.impl.getTableIndex" />
          <el-table-column label="职称名称" prop="titlesName">
          </el-table-column>
          <el-table-column label="职称编码" prop="titlesCode">
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="onTitleEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('titlesPage:titlesPage:titleEdit')">
                编辑
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('titlesPage:titlesPage:delete')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="titlesPage.SysTitles.impl.totalCount"
            :current-page="titlesPage.SysTitles.impl.currentPage"
            :page-size="titlesPage.SysTitles.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="titlesPage.SysTitles.impl.onCurrentPageChange"
            @size-change="titlesPage.SysTitles.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysTitlesController, DictionaryController } from '@/api';
import titleEdit from '@/views/baseInfo/titleEdit.vue';

export default {
  name: 'titlesPage',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      titlesPage: {
        formFilter: {
          titleName: undefined
        },
        formFilterCopy: {
          titleName: undefined
        },
        SysTitles: {
          impl: new TableWidget(this.loadSysTitlesWidgetData, this.loadSysTitlesVerify, true, true, 'createTime', 1)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetTitlesPage () {
      this.$refs.titlesPageFilter.resetFields();
      this.refreshTitlesPage(true);
    },
    /**
     * 系统职称表数据获取函数，返回Promise
     */
    loadSysTitlesWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysTitlesDtoFilter: {
          titlesName: this.titlesPage.formFilterCopy.titleName
        }
      }
      return new Promise((resolve, reject) => {
        SysTitlesController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.titlesPage.SysTitles.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.titlesPage.SysTitles.impl.currentRow.id, 'id');
              this.$refs.sysTitles.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 系统职称表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysTitlesVerify () {
      this.titlesPage.formFilterCopy.titleName = this.titlesPage.formFilter.titleName;
      return true;
    },
    /**
     * 更新职称管理
     */
    refreshTitlesPage (reloadData = false) {
      if (reloadData) {
        this.titlesPage.SysTitles.impl.refreshTable(true, 1);
      } else {
        this.titlesPage.SysTitles.impl.refreshTable();
      }
      if (!this.titlesPage.isInit) {
        // 初始化下拉数据
      }
      this.titlesPage.isInit = true;
    },
    /**
     * 新增
     */
    onTitleEditAddClick () {
      let params = {};

      this.$dialog.show('新增', titleEdit, {
        area: '500px'
      }, params).then(res => {
        this.refreshTitlesPage();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onTitleEditClick (row) {
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', titleEdit, {
        area: '500px'
      }, params).then(res => {
        this.titlesPage.SysTitles.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      SysTitlesController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.titlesPage.SysTitles.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onResume () {
      this.refreshTitlesPage();
    },
    initFormData () {
    },
    formInit () {
      this.refreshTitlesPage();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
